import React from 'react'
import Edit from '../../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import { isNotMultiplierField } from '../multiplier'

const EditOrderItem = props => {
  const { orderId, orderItemId } = props.params

  return (
    <Edit
// @ts-ignore
      title='Edit Order Item'
      fields={fields.filter(isNotMultiplierField)}
      apiPath={`admin/order_items/${orderItemId}`}
      successRedirectPath={`/ecommerce/orders/${orderId}/items`}
      buildMenuItems={menuItems}
    />
  )
}

export default EditOrderItem
